module.exports = __webpack_public_path__ + "3878f26df7349951af612087ef4f500d.png";